<template>
  <common
    :searchFrom="searchFrom"
    :tableTitle="tableTitle"
    :list="list"
    @crudClick="crudClick"
    :total="total"
    :arrPageSize="arrPageSize"
    :pageSize="searchFrom.pageSize"
    :BoolModal="isshowModal"
    :title="titleModal"
    @changeBindModal="changeBindModal"
    @closedeleteModal="closedeleteModal"
    :unChange="unChange"
    :footerHide="footerHide"
    :width="width"
    :loading="loading"
    :maskClosable="maskClosable"
    :current.sync="current"
    @pageClick="getList"
    ref="common"
  >
    <template slot="add">
      <FormItem>
        <Button type="primary" @click="crudClick(0, 'add')" icon="md-add">
          {{ $t("add") }}
        </Button>
      </FormItem>
    </template>

    <div slot="content">
      <template v-if="crudText == 'delete'">
        <p>{{ $t("titleModal") }}</p>
      </template>
      <template v-else>
        <Form
          label-position="right"
          :model="dataDetails"
          :label-width="130"
          :rules="ruleFrom"
          ref="dataDetails"
        >
          <FormItem :label="$t('unitName')" prop="name">
            <i-Input
              v-model="dataDetails.name"
              placeholder="Please Enter Name"
            ></i-Input>
          </FormItem>
          <FormItem :label="$t('sort')" prop="sort">
            <i-Input
              v-model="dataDetails.sort"
              placeholder="Please Enter sort"
            ></i-Input>
          </FormItem>
        </Form>
      </template>
    </div>
  </common>
</template>

<script>
import { getUnit, add, del, update, getDetails } from "@/api/system/unit";
import common from "_c/common-body";
import boxMes from "@/utils/message";
import format from "@/utils/format";

export default {
  name: "unit",
  components: {
    common
  },
  data() {
    var isNum = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("Cannot be empty"));
      }
      this.$nextTick(() => {
        var reg = new RegExp("^[0-9]*$");
        if (!reg.test(value)) {
          callback(new Error("Must be a number"));
        } else {
          callback();
        }
      });
    };
    return {
      current: 1,
      arrPageSize: [15, 30, 50, 100],
      maskClosable: false,
      loading: true,
      width: 600,
      list: [],
      searchFrom: {
        page: 1,
        pageSize: 15,
        keywords: "",
        country_id: ""
      },
      // Warehouse总数据
      total: 0,
      // 详情模态框显示/隐藏
      isshowModal: false,
      // 数据详情
      dataDetails: {},
      // 删除模态显示/隐藏
      Delmodal1: false,
      // 模态框标题
      isshowModalTitle: "",
      disabled: false,
      ruleFrom: {
        name: [
          {
            required: true,
            message: "city_name cannot be empty",
            trigger: "blur"
          }
        ],
        sort: [{ required: true, validator: isNum, trigger: "blur" }]
      },
      footerHide: false,
      crudText: "",
      titleModal: "",
      countryList: [],
      deleteModal: false,
      delId: 0,
      preForm: {},
      unChange: true
    };
  },
  computed: {
    tableTitle() {
      let columns = [];
      columns.push({
        title: this.$t("unitName"),
        key: "name",
        align: "center",
        minWidth: 100,
        tooltip: true
      });
      columns.push({
        title: this.$t("sort"),
        key: "sort",
        align: "center",
        minWidth: 150
      });
      columns.push({
        title: this.$t("createTime"),
        align: "center",
        key: "create_time",
        minWidth: 160
      });
      columns.push({
        title: this.$t("upTime"),
        align: "center",
        key: "update_time",
        minWidth: 160
      });
      columns.push({
        title: this.$t("operation"),
        slot: "operation",
        align: "center",
        width: 300
      });
      return columns;
    }
  },
  watch: {
    dataDetails: {
      handler: function(nowVal) {
        var $this = this;
        for (let i in $this.dataDetails) {
          if (nowVal[i] !== $this.preForm[i]) {
            $this.unChange = false;
            break;
          } else {
            $this.unChange = true;
          }
        }
      },
      deep: true
    }
  },
  mounted() {
    // this.getOtherList();
    this.getList(this.searchFrom);
  },
  methods: {
    changeBindModal(val) {
      if (!val) {
        this.closedeleteModal(false);
      } else {
        if (this.crudText === "delete") {
          this.deleteList(this.delId);
        } else {
          this.confirm("dataDetails");
        }
      }
    },
    closedeleteModal(e) {
      if (e === false) {
        this.isshowModal = false;
        if (this.crudText != "delete") {
          this.$refs["dataDetails"].resetFields();
        }
      }
    },
    confirm(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.crudText === "add") {
            this.addList();
          } else {
            this.updateList();
          }
        } else {
          console.log(this.$t("fail"));
        }
      });
    },
    crudClick(item, text) {
      this.titleModal = this.$t(text);
      this.maskClosable = false;
      this.width = 600;
      this.footerHide = false;
      this.unChange = true;
      this.disabled = false;
      this.dataDetails = {};
      this.preForm = {};
      if (item !== 0) {
        if (text == "delete") {
          this.width = 300;
          this.delId = item.id;
          this.unChange = false;
          this.maskClosable = true;
        } else {
          if (text === "show") {
            this.disabled = true;
            this.footerHide = true;
            this.maskClosable = true;
          }
          this.dataDetails = {};
          this.preForm = {};
          this.getDetailsList(item.id, text);
        }
      }
      this.isshowModal = true;
      this.crudText = text;
    },
    getDetailsList(id) {
      getDetails(id)
        .then(res => {
          if (this.crudText == "update") {
            delete res.data.payload.country;
          }
          this.dataDetails = res.data.payload;
          this.preForm = JSON.parse(JSON.stringify(res.data.payload));
        })
        .catch(err => {
          console.log(err);
        });
    },
    getList(data) {
      this.loading = true;
      getUnit(data)
        .then(res => {
          if (!res.data.status) {
            this.loading = false;
            boxMes.alertMes(res, this);
            return;
          }
          this.total = res.data.payload.total;
          this.list = res.data.payload.rows;
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    addList() {
      delete this.dataDetails.support_currency_id;
      add(this.dataDetails).then(res => {
        boxMes.alertMes(res, this);
      });
    },
    updateList() {
      delete this.dataDetails.country;
      update(this.dataDetails).then(res => {
        boxMes.alertMes(res, this);
      });
    },
    deleteList(id) {
      del(id).then(res => {
        boxMes.alertMes(res, this);
      });
    }
  }
};
</script>

<style scoped lang="less"></style>
